var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.name,{tag:"component",staticClass:"text-cut",attrs:{"title":_vm.value}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }